<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="pgepubid00002">
<h2 class="nobreak">LIST OF ILLUSTRATIONS</h2>
</div>
<table>
<tbody><tr><td>“Object—matrimony,” he retorted</td>
<td class="tdr"><a class="pginternal" href="#/3186253215635795556_74210h2.htm#Page_0"> <i>Frontispiece</i></a></td>
</tr>
<tr><td class="tdr" colspan="2"><span class="smcap"><span class="small">Facing Page</span></span></td>
</tr>
<tr><td>“Yes, I heard,” Millicent could hardly articulate</td>
<td class="tdr"><a class="pginternal" href="#/3186253215635795556_74210h7.htm#Page_16">      16</a></td>
</tr>
<tr><td>“Who’s there?” she called, as heavy steps approached</td>
<td class="tdr"><a class="pginternal" href="#/3186253215635795556_74210h14.htm#Page_142">      142</a></td>
</tr>
<tr><td>“Hush!” he whispered. “No noise. Look——”</td>
<td class="tdr"><a class="pginternal" href="#/3186253215635795556_74210h20.htm#Page_256">      256</a></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3186253215635795556_74210-h-5.htm.vue?01e8bf48